export default {
  nav: {
    dashboard: 'Inicio',
    markets: 'Mercados',
    trade: 'Operar',
    support: 'Soporte',
    profile: 'Perfil'
  },
  trade: {
    title: 'Operar',
    spot: 'Spot',
    futures: 'Futuros',
    copytrading: 'Copytrading',
    leaderboard: 'Clasificación',
    myTraders: 'Mis Traders',
    myTrades: 'Mis Operaciones',
    becomeTrader: 'Ser Trader',
    buy: 'Comprar',
    sell: 'Vender',
    price: 'Precio',
    amount: 'Cantidad',
    total: 'Total',
    available: 'Disponible',
    margin: 'Margen',
    leverage: 'Apalancamiento',
    orderType: 'Tipo de Orden',
    limit: 'Límite',
    market: 'Mercado',
    tpsl: 'TP/SL',
    openChart: 'Abrir Gráfico',
    selectToken: 'Seleccionar Token',
    positionsHistory: 'Historial de Posiciones',
    copyingActiveTitle: 'Copiado Activo',
    copyingActiveMessage: 'Tu billetera está conectada al copytrading. Actualmente no es posible abrir operaciones en mercados spot y futuros ya que el margen está siendo utilizado en posiciones de copia activas.\n\nPara restaurar el trading, desconéctate del trader y detén el copiado de operaciones.',
    becomeTraderTitle: 'Convertirse en Trader',
    becomeTraderMessage: 'Para convertirte en copy trader y ganar no solo con tus propios fondos, necesitas obtener el nivel de cuenta VIP.\n\nEl estado VIP abre el acceso a conectar suscriptores, te permite escalar el trading usando su capital y recibir recompensas adicionales de las ganancias en operaciones copiadas.',
    cannotCopyTitle: 'No se pueden copiar múltiples traders',
    cannotCopyMessage: 'No puedes copiar múltiples traders simultáneamente ya que tu cuenta aún no ha alcanzado el estado Platinum.\n\nObtén el estado Platinum — y desbloquea la capacidad de copiar múltiples traders y diversificar estrategias.',
    copying: 'Copiando',
    copy: 'Copiar',
    roi: 'ROI',
    pnl: 'PnL',
    drawdown: 'Drawdown',
    followers: 'Seguidores',
    ok: 'OK',
    close: 'Cerrar'
  },
  maintenance: {
    title: '¡Estimados usuarios!',
    message1: 'Actualmente se están realizando trabajos técnicos para optimizar y mejorar el sistema.',
    message2: 'Debido a esto, algunas funciones pueden funcionar de manera inestable o con limitaciones temporales.',
    message3: 'La aplicación continúa funcionando con normalidad, el acceso a la funcionalidad principal se mantiene.',
    message4: 'Gracias por su comprensión. Estamos trabajando para que todo funcione de la manera más rápida y estable posible.',
    button: 'Entendido'
  },
  settings: {
    title: 'Configuración',
    language: 'Idioma',
    theme: 'Tema',
    support: 'Soporte',
    dark: 'Oscuro',
    light: 'Claro'
  },
  profile: {
    title: 'Perfil',
    balance: 'Saldo',
    withdraw: 'Retirar',
    totalBalance: 'Tu saldo total de activos',
    viewHistory: 'Ver historial de transacciones',
    referrals: 'Referidos',
    referralsCount: '{count} Referidos',
    rewards: 'Recompensas',
    rewardsCount: '{count} Recompensas',
    rewardsMessage: 'Las recompensas se acreditan automáticamente a tu saldo',
    yourCode: 'Tu código:',
    copy: 'Copiar',
    copied: '¡Copiado!',
    pnl7d: '7D PnL',
    pnl30d: '30D PnL',
    pnl90d: '90D PnL',
    aum: 'AUM',
    roi: 'ROI',
    roi90d: 'ROI (90D)',
    unsubscribe: 'Cancelar suscripción',
    resume: 'Reanudar',
    resuming: 'Reanudando...',
    inactiveTitle: '¡Tu solicitud ha sido aceptada exitosamente!',
    inactiveMessage: 'Los fondos se desbloquearán en 21 días: este tiempo es necesario para cerrar todas las operaciones, calcular las ganancias y completar correctamente la copia. Esto se hace para tu seguridad y protección del capital. Si deseas continuar copiando a este trader, haz clic en el botón "Reanudar".',
    inviteButton: '¡Invita a un referido y copia juntos!',
    referralLimitMessage: 'Actualmente no es posible conectar nuevos referidos a este trader. Ha establecido un límite en el número de usuarios permitidos para copiar sus operaciones',
    ok: 'Ok',
    vipTier: 'Nivel VIP',
    yourProgress: 'Tu progreso',
    currentTier: 'Nivel actual',
    progressTooltip: 'Tu progreso de nivel crecerá a medida que aumentes tu actividad comercial, actividad de depósitos y volumen total de operaciones.',
    currentExp: 'EXP actual:',
    expToNext: 'EXP al siguiente nivel:',
    maxLevel: '¡Nivel máximo alcanzado!',
    unsubscribeConfirm: '¿Dejar de copiar las operaciones del trader? Después de desactivar, dejarás de recibir ganancias de su trading.',
    no: 'No',
    yes: 'Sí',
    processing: 'Procesando...',
    withdrawFunds: 'Retirar fondos',
    confirmWithdrawal: 'Confirmar retiro',
    enterPin: 'Ingresar código PIN',
    pinDescription: 'Por favor, ingresa tu código PIN para confirmar el retiro',
    network: 'Red',
    selectNetwork: 'Seleccionar red',
    walletAddress: 'Dirección de billetera',
    enterWallet: 'Ingresar dirección de billetera',
    amount: 'Cantidad (USDT)',
    enterAmount: 'Ingresar cantidad',
    available: 'Disponible:',
    minMax: 'Mín: {min} USDT | Máx: {max} USDT por transacción',
    cancel: 'Cancelar',
    continue: 'Continuar',
    confirm: 'Confirmar',
    back: 'Atrás',
    withdrawalSubmitted: 'Solicitud de retiro enviada',
    withdrawalMessage: 'Tu solicitud está siendo revisada, gracias por esperar',
    openPositionsErrorTitle: '¡Estimado usuario!',
    openPositionsErrorMessage: 'Su solicitud no fue procesada porque su cuenta tiene operaciones abiertas usando margen cruzado.\nPor favor, cierre todas las posiciones activas e intente nuevamente.',
    transactionHistory: 'Historial de transacciones',
    loadingHistory: 'Cargando historial...',
    noTransactions: 'Aún no hay transacciones',
    deposit: 'Depósito',
    withdrawal: 'Retiro',
    pending: 'Pendiente',
    approved: 'Aprobado',
    completed: 'Completado',
    declined: 'Rechazado',
    failed: 'Fallido',
    networkLabel: 'Red:',
    addressLabel: 'Dirección:',
    reasonLabel: 'Razón:',
    noReason: 'No se proporcionó razón',
    na: 'N/A',
    levels: {
      bronze: {
        benefit1: 'Comisiones de trading regulares',
        benefit2: 'Límites de retiro estándar',
        benefit3: 'Recompensas mensuales',
        benefit4: 'Trading con margen hasta 3x apalancamiento'
      },
      silver: {
        benefit1: '5% menos en comisiones de trading',
        benefit2: 'Bonos mensuales',
        benefit3: 'Trading con margen hasta 5x apalancamiento'
      },
      gold: {
        benefit1: '10% menos en comisiones de trading',
        benefit2: 'Soporte prioritario al cliente',
        benefit3: 'Acceso anticipado a nuevos instrumentos',
        benefit4: 'Trading con margen hasta 10x apalancamiento'
      },
      platinum: {
        benefit1: '25% menos en comisiones de trading',
        benefit2: 'Gerente de cuenta personal',
        benefit3: 'Invitaciones a comunidades privadas',
        benefit4: 'Trading con margen hasta 50x apalancamiento'
      },
      vip: {
        benefit1: 'Comisiones de trading cero',
        benefit2: 'Acceso completo al escritorio OTC',
        benefit3: 'Gerente VIP 24/7',
        benefit4: 'Límites y términos personalizados',
        benefit5: 'Invitaciones a eventos privados offline',
        benefit6: 'Trading con margen hasta 100x'
      }
    }
  },
  faq: {
    title: 'FAQ / Soporte',
    footerText: 'Si no encontraste la respuesta a tu pregunta, no dudes en contactar',
    customerSupport: 'soporte al cliente',
    footerEnd: "para obtener más ayuda. O por correo electrónico:",
    questions: {
      q1: '¿Qué es el copy trading?',
      q2: '¿Cómo empiezo a copiar a un trader?',
      q3: '¿Puedo dejar de copiar en cualquier momento?',
      q4: '¿Quién controla mis fondos?',
      q6: '¿Qué pasa si el trader entra en pérdidas?',
      q7: '¿Puedo copiar múltiples traders al mismo tiempo?',
      q8: '¿Con qué frecuencia se actualiza la estadística del trader?',
      q9: '¿Dónde puedo ver mis resultados?',
      q10: '¿Puede un trader cambiar su estrategia?',
      q11: '¿Es seguro copiar operaciones?'
    },
    answers: {
      a1: 'El copy trading es un mecanismo que replica automáticamente las operaciones de un trader seleccionado en tiempo real.',
      a2: 'Elige un trader, haz clic en "Conectar" y confirma la cantidad que deseas asignar para copiar.',
      a3: 'Sí, puedes dejar de copiar y cerrar posiciones en cualquier momento, sujeto a las condiciones del trader.',
      a4: 'Tus fondos permanecen en tu billetera personal/cuenta de intercambio. El trader no tiene acceso a ellos.',
      a6: 'Las pérdidas se distribuyen proporcionalmente a tu cantidad asignada. El trader no asume responsabilidad financiera por el resultado.',
      a7: 'Sí, si tu saldo lo permite. Esto puede ayudar a diversificar el riesgo.',
      a8: 'Las estadísticas se actualizan en tiempo real o con un retraso mínimo.',
      a9: 'En la sección "Dashboard" o "Profile", puedes encontrar información detallada sobre ganancias, pérdidas y posiciones activas.',
      a10: 'Sí, los traders son libres de ajustar su estrategia en cualquier momento, y todos los cambios se reflejan automáticamente en las operaciones copiadas.',
      a11: 'La seguridad depende del nivel de riesgo del trader que elijas. Recomendamos revisar ROI, PnL y métricas de riesgo antes de conectar.'
    }
  },
  markets: {
    title: 'Mercados',
    searchPlaceholder: 'Buscar por nombre o símbolo',
    loadingMarkets: 'Cargando mercados…',
    unableToLoad: 'No se pudieron cargar los mercados',
    tryAgain: 'Intentar de nuevo',
    nothingFound: 'No se encontró nada',
    nothingFoundMessage: 'Intenta cambiar tus opciones de búsqueda o clasificación.',
    loading: 'Cargando...',
    loadMore: 'Cargar más',
    chooseAsset: 'Elige un activo para ver información',
    chooseAssetMessage: 'Selecciona un mercado de la lista de la izquierda para ver información detallada de precio y proyecto aquí.',
    sortSymbol: 'Símbolo',
    sortPrice: 'Precio',
    sort24h: '24h %',
    sortVolume: 'Volumen'
  },
  marketDetails: {
    loading: 'Cargando...',
    loadingData: 'Cargando datos del mercado…',
    unableToLoad: 'No se pudieron cargar los datos del mercado',
    tryAgain: 'Intentar de nuevo',
    last24h: 'Últimas 24 horas',
    priceChart: 'Gráfico de precios',
    hoursAgo: 'Hace 24h',
    now: 'Ahora',
    marketInfo: 'Información del mercado',
    marketCap: 'Capitalización de mercado',
    circulatingSupply: 'Suministro circulante',
    volume24h: 'Volumen 24h',
    projectInfo: 'Información del proyecto',
    marketIdNotProvided: 'ID del mercado no proporcionado',
    marketNotFound: 'Mercado no encontrado',
    errorLoading: 'Error al cargar los datos del mercado'
  },
  dashboard: {
    title: 'Panel de control',
    periods: {
      today: 'Hoy',
      week: 'Semana',
      month: 'Mes',
      allTime: 'Todo el tiempo'
    },
    loadingData: 'Cargando datos del panel…',
    unableToLoad: 'No se pudo cargar el panel',
    tryAgain: 'Intentar de nuevo',
    totalBalance: 'Balance total',
    unrealizedPnl: 'PnL no realizado',
    realizedPnl: 'PnL realizado',
    totalRoi: 'ROI total',
    positions: 'Posiciones',
    open: 'Abiertas',
    closed: 'Cerradas',
    winRate: 'Tasa de ganancia',
    avgPnlVolume: 'PnL promedio / Volumen',
    avgPnl: 'PnL promedio',
    volume: 'Volumen',
    profitabilityChart: 'Gráfico de rentabilidad',
    openPositions: 'Posiciones abiertas',
    positionsHistory: 'Historial de posiciones',
    noOpenPositions: 'No hay posiciones abiertas',
    crossMargin: 'Margen cruzado',
    leverage: 'Apalancamiento',
    margin: 'Margen',
    pnlUnrealized: 'PnL (No realizado)',
    coinHiddenAlert: 'El trader ha ocultado temporalmente el par de trading para prevenir trading con información privilegiada y el intercambio no autorizado de detalles de la operación hasta que se cierre la posición.',
    failedToGetUserId: 'No se pudo obtener el ID del usuario',
    failedToGetUserData: 'No se pudieron obtener los datos del usuario',
    errorLoadingData: 'Error al cargar los datos del panel',
    requestTimeout: 'Tiempo de espera agotado'
  },
  positionsHistory: {
    title: 'Historial de posiciones',
    loadingHistory: 'Cargando historial de posiciones…',
    unableToLoad: 'No se pudieron cargar las posiciones',
    tryAgain: 'Intentar de nuevo',
    noClosedPositions: 'No hay posiciones cerradas',
    entryPrice: 'Precio de entrada',
    exitPrice: 'Precio de salida',
    margin: 'Margen',
    realizedPnl: 'PnL realizado',
    leverage: 'Apalancamiento',
    dateOpened: 'Fecha de apertura',
    dateClosed: 'Fecha de cierre'
  },
  admin: {
    balanceDetails: {
      title: 'Detalles del saldo',
      loading: 'Cargando datos del saldo...',
      noData: 'No hay suficientes datos disponibles',
      balance: 'Saldo:',
      availableBalance: '• Saldo disponible',
      unrealizedProfit: '• Ganancia no realizada',
      tradingCredit: '• Crédito comercial',
      marginUsed: '• Margen utilizado',
      openPositions: '• Posiciones abiertas',
      close: 'Cerrar',
      edit: 'Editar',
      cancel: 'Cancelar',
      save: 'Guardar',
      balanceHint: 'Cantidad total del saldo',
      tradingCreditHint: 'Cantidad del crédito comercial',
      readonlyNote: 'Los siguientes campos se calculan automáticamente:',
      create: 'Crear datos de saldo'
    }
  },
  common: {
    days: 'd',
    usdt: 'USDT'
  },
  deposit: {
    title: 'Depósito',
    selectToken: 'Seleccionar Token',
    selectNetwork: 'Seleccionar Red',
    connected: 'Conectado',
    notConnected: 'No conectado',
    token: 'Token',
    network: 'Red',
    backToToken: 'Volver a selección de token',
    loadingAddress: 'Cargando dirección de depósito...',
    noWalletTitle: 'Sin Billetera Conectada',
    noWalletMessage: 'Por favor conecta tu billetera a través de la página de inicio para recibir depósitos.',
    copyAddress: 'Copiar Dirección',
    copied: '¡Copiado!',
    warning1: 'Envía solo {token} ({network}) a esta dirección',
    warning2: 'Depósito mínimo: {min} USDT',
    warning3: 'Fondos acreditados automáticamente después de la confirmación',
    warning4: 'No se cobran comisiones por depósitos'
  }
}

